<app-modal class="popup-confirmation">
    <div class="modal-header" modal-header>
        <h5 class="modal-title">{{ "admin.plants.confirmationModal.title" | translate }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <p>{{ "admin.plants.confirmationModal.label" | translate }}:</p>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <div class="paths">
            <div class="path" *ngFor="let path of paths">
                <app-icon class="icon" library="fontawesome" variant="fa-file" type="info" simple="true"></app-icon>
                <span class="text">{{ path }}</span>
            </div>
        </div>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    [disabled]="isLoading"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isLoading"
                    (click)="onConfirm()"
                    data-dismiss="modal">{{ "generic.buttons.confirm" | translate }}
        </app-button>
    </div>
</app-modal>

